function Container({ children }) {
  return (
    <div className="max-w-[1920px] mx-auto px-[240px] w-full relative">
      {children}
    </div>
  );
}

export default Container;
